export default function stopPropagation(event) {
	return event.stopPropagation();
}
